import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import Datetime from 'react-datetime'

export default function My_timesheet() {
    const [listMemberTimeArray, setListMemberTimeArray] = useState([]);
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        var company_id = localStorage.getItem('mem_company_id');
        var user_id = localStorage.getItem('member_id');

        var obj = {
            user_id: user_id,
            company_id: company_id
        }

        console.log(obj)

        $.ajax({
            type: 'POST',
            url: 'getMemberTimesheetDetails.php',
            data: obj,
            dataType: 'json',
            cache: false,
            success: function (result) {
                console.log(result)
                if (Array.isArray(result) && result.length > 0) {

                    setListMemberTimeArray(result);
                    $('.camp_log_pop').show();

                } else {

                    showAlert('No time history found.');

                }
            }
        });
    }, [])
    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    const downloadPDF = () => {
        const doc = new jsPDF()

        doc.text('Timesheet', 14, 15)
        doc.text(`Generated On: ${new Date().toDateString()}`, 14, 25)
        doc.text(`Name: ${localStorage.getItem('membername')}`, 14, 35)

        autoTable(doc, {
            head: [['#', 'Task', 'Task Details', 'Date', 'Start Time', 'End Time', 'Worked Time']],
            body: listMemberTimeArray.map((task, index) => ([
                index + 1,
                task.task_name,
                task.task_details,
                task.dateofWork,
                task.start_time,
                task.end_time,
                task.time_worked
            ])),
            startY: 45
        })

        doc.save('timesheet-report.pdf');
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>My Timesheet</h2>
                    <p className='fullwidth pull_left pb-30'>Here you can view your total working hours</p>
                    <div className='vl_dsh_btn_holder mb-10 text_right'>
                        <button onClick={downloadPDF}>
                            Download PDF <i className='ri-download-2-fill'></i>
                        </button>
                    </div>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_listing_area'>

                        {listMemberTimeArray.map((item, index) => {

                            return (
                                <div className='resource_card_one_third' key={index}>
                                    <div className='resource_inner'>
                                        <div className='fullwidth pull_left pt-21'>
                                            <h3>{item.project_name}</h3>
                                            <div className='fullwidth pull_left'>
                                                <span className='fullwidth pull_left'>Date : {item.dateofWork}</span>
                                            </div>
                                        </div>
                                        <div className='divider'>&nbsp;</div>
                                        <div className='vl_dsh_one_full'>
                                            <p>Task Name: {item.task_name}</p>
                                        </div>

                                        <div className='vl_dsh_one_full'>
                                            <p>{item.time_worked}</p>
                                            <div className='fullwidth pull_left pt-15'>
                                                <span className='fullwidth pull_left'>Start time : {item.start_time}</span>
                                                <span className='fullwidth pull_left'>End time : {item.end_time}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </section>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>


    )
}
